import { getQueryParameters, regionApi, regionRequest } from './regionApi';

export const regionAssetApi = regionApi.injectEndpoints({
  endpoints: (build) => ({
    getAssetByAccount: build.query<any, Record<string, any>>({
      query: ({ account }) =>
        regionRequest(account?.region, 'asset', {
          method: 'GET',
          params: getQueryParameters(account, {
            refresh: true
          })
        }),

      providesTags: (_result, _error, { account }) => [
        {
          type: 'Asset',
          id: account?.group_id || 0
        },
        { type: 'Asset' }
      ],

      transformResponse: (result, _meta, { account }) =>
        getQueryParameters(account, {
          data: result
        })
    }),

    asset: build.query<any, Record<string, any>>({
      query: ({ region, account, instance }) =>
        regionRequest(region, 'asset', {
          method: 'GET',
          params: getQueryParameters({
            ...account,
            ...instance
          })
        })
    })
  }),

  overrideExisting: false
});

export const {
  useGetAssetByAccountQuery,
  useLazyGetAssetByAccountQuery,
  useAssetQuery,
  useLazyAssetQuery
} = regionAssetApi;
